{
  "default" : [
    {
      "shortName" : "ECTDELTA",
      "fullName" : "ECT Delta Terminal B.V.",
      "location" : {
        "name" : "Rotterdam",
        "locationUnCode" : "NLRTM",
        "countryUnCode" : "NL",
        "euLocation" : true
      },
      "quaysForPlanning" : [
        "DDE",
        "DDN"
      ],
      "multiQuay" : false
    },
    {
      "shortName" : "EUROMAX",
      "fullName" : "Euromax Terminal B.V.",
      "location" : {
        "name" : "Rotterdam",
        "locationUnCode" : "NLRTM",
        "countryUnCode" : "NL",
        "euLocation" : true
      },
      "quaysForPlanning" : [
        "EMX"
      ],
      "multiQuay" : false
    },
    {
      "shortName" : "RWG",
      "fullName" : "Rotterdam World Gateway (RWG)",
      "location" : {
        "name" : "Rotterdam",
        "locationUnCode" : "NLRTM",
        "countryUnCode" : "NL",
        "euLocation" : true
      },
      "quaysForPlanning" : [
        "RWG"
      ],
      "multiQuay" : false
    }
  ],
  "kt" : [
    {
      "shortName" : "EUROMAXN4",
      "fullName" : "Euromax Navis4 Terminal B.V.",
      "location" : {
        "name" : "Rotterdam",
        "locationUnCode" : "NLRTM",
        "countryUnCode" : "NL",
        "euLocation" : true
      },
      "quaysForPlanning" : [
        "EMXN4"
      ],
      "multiQuay" : false
    }
  ],
  "local" : [],
  "prod" : [],
  "sc" : []
}
